/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type ConsentPCCItemStatus = typeof ConsentPCCItemStatus[keyof typeof ConsentPCCItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConsentPCCItemStatus = {
  NoLinkSent: 'NoLinkSent',
  NotStarted: 'NotStarted',
  Completed: 'Completed',
  Unknown: 'Unknown',
} as const;
